import axios from 'axios';

// CORREGIDO: Usar ruta relativa para el proxy
const API_BASE_URL = '';  // Cadena vacía para usar el proxy

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Pisos
export const getPisos = () => api.get('/pisos');
export const createPiso = (pisoData) => api.post('/pisos', pisoData);

// Trabajos
export const getTrabajos = () => api.get('/trabajos');
export const createTrabajo = (trabajoData) => api.post('/trabajos', trabajoData);

// Extras
export const getExtras = () => api.get('/extras');
export const createExtra = (extraData) => api.post('/extras', extraData);

// Configuración
export const getConfiguracion = () => api.get('/configuracion');
export const updateConfiguracion = (configData) => api.put('/configuracion', configData);

// Resumen
export const getResumenMensual = (year, month) => api.get(`/resumen/${year}/${month}`);

//Borrar pisos 
export const deletePiso = (pisoId) => api.delete(`/pisos/${pisoId}`);
export const deleteTrabajo = (trabajoId) => api.delete(`/trabajos/${trabajoId}`);